export const notificationButtons = {
    todo: "todo",
    reports: "reports",
};
